import React, { Component } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bulma/css/bulma.min.css";
import 'bootstrap/dist/css/bootstrap.min.css';

// import Header from "./components/Header";
import Footer from "./components/Footer";

import Routes from "./route";
import { Toaster } from "react-hot-toast";

class App extends Component {
  render() {
    return (
      <div>
        <Toaster position="top-right" reverseOrder={false} />
        <Routes />
        <Footer />
      </div>
    );
  }
}

export default App;
